export var MAX_WIDTH_FOR_TOOLTIP = 120;
//# sourceMappingURL=constants.js.map